



















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'TicketSelectionOdd',
    inheritAttrs: false,
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
        displayValue: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        isOddNameHidden: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
});
